@if (currencyCode) {
  <div class="configuration-container">
    <div class="configuration-content credits">
      <p class="configuration-title mb-2">{{ 'settings.creditsTitle' | translate }}</p>

      <div class="credits__list">
        @for (credit of credits; track $index) {
          <a
            class="credits__list-item text-decoration-none"
            [attr.data-best-value]="translateService.instant('settings.bestValue')"
            [attr.data-promo-value]="translateService.instant('settings.blackFriday')"
            (click)="buySelectedCredit(credit)"
            [ngClass]="{ best: credit.best, 'promo__blackFriday forceDefaultColors': credit.amount_promo && credit.is_promo && appService.isEventSale() }"
          >
            <i class="fa-solid fa-shield-check"></i>
            <div class="credits__desc">
              <p class="mb-0">{{ credit.description }}</p>
            </div>
            <div class="credits__info">
              <p class="mb-0 value">
                <span>{{ appService.currencyCodeFor(currency) }}</span> {{ ((credit.is_promo && appService.isEventSale() ? credit.amount_promo : credit.amount) * credit.quantity) / 100 | ldecimal }}
              </p>
              <p class="mb-0">{{ (credit.is_promo && appService.isEventSale() ? credit.amount_promo : credit.amount) / 100 | lcurrency: currencyCode }}{{ 'settings.credit' | translate }}</p>
            </div>
          </a>
        }
        <a class="credits__list-item credits__list-item--custom text-decoration-none" (click)="openCustomCreditPackModal()">
          <div class="credits__desc">
            <p class="mb-0"><i class="fa-solid fa-shield-check mr-1"></i>{{ 'settings.moreCreditsTitle' | translate }}</p>
          </div>
          <div class="credits__info">
            <p class="mb-0" [innerHTML]="'settings.moreCreditsDescription' | translate"></p>
          </div>
        </a>
      </div>
    </div>
  </div>
}

@if (creditLogs?.length > 0) {
  <div class="configuration-item"></div>
  <div class="configuration-container">
    <div class="credits__history">
      <p class="configuration-title mb-2">{{ 'settings.credit_history' | translate }}</p>
      <table class="credits__history-table">
        <thead>
          <tr>
            <th>{{ 'settings.date' | translate }}</th>
            <th>{{ 'settings.credits' | translate }}</th>
            <th>{{ 'settings.user' | translate }}</th>
            <th>{{ 'settings.description' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (creditLog of creditLogs; track $index) {
            <tr>
              <td>{{ creditLog.created_at | dateTime }}</td>
              <td [ngClass]="{ negative: creditLog.amount < 0, positive: creditLog.amount >= 0 }">{{ (creditLog.amount > 0 ? '+' : '') + creditLog.amount }}</td>
              <td title="{{ creditLog.user_email }}">{{ creditLog.user_email || creditLog.user_phone }}</td>
              <td title="{{ creditLog.verifications }}">{{ creditLog.verifications }}</td>
              <td>
                @if (creditLog.document_id && currentUser?.currentPermissions?.view_documents_oz) {
                  <a [routerLink]="['/documentos', creditLog.document_id]" target="_blank" class="document-link">
                    {{ 'settings.document' | translate }}
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                  </a>
                } @else if (!creditLog.document_id && creditLog.url_nfse) {
                  <a [href]="creditLog.url_nfse" target="_blank" class="document-link">
                    {{ 'settings.receipt' | translate }}
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                  </a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="d-flex justify-content-center mt-1">
        <button type="button" class="btn-M btn-text" *ngIf="!creditLogIsLastPage" (click)="loadCreditLogs({ page: creditLogPageNumber + 1 })">{{ 'button.loadMore' | translate }}</button>
      </div>
    </div>
  </div>
}
